'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Store = require('orbit-db-store');

var DocumentIndex = require('./DocumentIndex');

var pMap = require('p-map');

var Readable = require('readable-stream');

var replaceAll = function replaceAll(str, search, replacement) {
  return str.toString().split(search).join(replacement);
};

var DocumentStore = /*#__PURE__*/function (_Store) {
  _inherits(DocumentStore, _Store);

  var _super = _createSuper(DocumentStore);

  function DocumentStore(ipfs, id, dbname, options) {
    var _this;

    _classCallCheck(this, DocumentStore);

    if (!options) options = {};
    if (!options.indexBy) Object.assign(options, {
      indexBy: '_id'
    });
    if (!options.Index) Object.assign(options, {
      Index: DocumentIndex
    });
    _this = _super.call(this, ipfs, id, dbname, options);
    _this._type = 'docstore';
    return _this;
  }

  _createClass(DocumentStore, [{
    key: "get",
    value: function get(key) {
      var _this2 = this;

      var caseSensitive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      key = key.toString();
      var terms = key.split(' ');
      key = terms.length > 1 ? replaceAll(key, '.', ' ').toLowerCase() : key.toLowerCase();

      var search = function search(e) {
        if (terms.length > 1) {
          return replaceAll(e, '.', ' ').toLowerCase().indexOf(key) !== -1;
        }

        return e.toLowerCase().indexOf(key) !== -1;
      };

      var mapper = function mapper(e) {
        return _this2._index.get(e);
      };

      var filter = function filter(e) {
        return caseSensitive ? e.indexOf(key) !== -1 : search(e);
      };

      return Object.keys(this._index._index).filter(filter).map(mapper);
    }
  }, {
    key: "query",
    value: function query(mapper) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Whether we return the full operation data or just the db value
      var fullOp = options.fullOp || false;
      return Object.keys(this._index._index).map(function (e) {
        return _this3._index.get(e, fullOp);
      }).filter(mapper);
    }
  }, {
    key: "batchPut",
    value: function batchPut(docs, onProgressCallback) {
      var _this4 = this;

      var mapper = function mapper(doc, idx) {
        return _this4._addOperationBatch({
          op: 'PUT',
          key: doc[_this4.options.indexBy],
          value: doc
        }, true, idx === docs.length - 1, onProgressCallback);
      };

      return pMap(docs, mapper, {
        concurrency: 1
      }).then(function () {
        return _this4.saveSnapshot();
      });
    }
  }, {
    key: "put",
    value: function put(doc) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!doc[this.options.indexBy]) {
        throw new Error("The provided document doesn't contain field '".concat(this.options.indexBy, "'"));
      }

      return this._addOperation({
        op: 'PUT',
        key: doc[this.options.indexBy],
        value: doc
      }, options);
    }
  }, {
    key: "putAll",
    value: function putAll(docs) {
      var _this5 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!Array.isArray(docs)) {
        docs = [docs];
      }

      if (!docs.every(function (d) {
        return d[_this5.options.indexBy];
      })) {
        throw new Error("The provided document doesn't contain field '".concat(this.options.indexBy, "'"));
      }

      return this._addOperation({
        op: 'PUTALL',
        docs: docs.map(function (value) {
          return {
            key: value[_this5.options.indexBy],
            value: value
          };
        })
      }, options);
    }
  }, {
    key: "del",
    value: function del(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this._index.get(key)) {
        throw new Error("No entry with key '".concat(key, "' in the database"));
      }

      return this._addOperation({
        op: 'DEL',
        key: key,
        value: null
      }, options);
    }
  }]);

  return DocumentStore;
}(Store);

module.exports = DocumentStore;